<template>
	<section
		class="video_or_image"
		:class="{'modal-open': theModalStatus === true}"
		:style="{'--padding-top': parsedData.padding_top + 'px', '--padding-bottom': parsedData.padding_bottom + 'px', '--padding-top-mobile': parsedData.padding_top_mobile + 'px', '--padding-bottom-mobile': parsedData.padding_bottom_mobile + 'px', '--size': this.size ? this.size : 'span 12'}"
	>
		<div class="container">
			<div class="video_or_image__inner">
				<h2 v-html='title'></h2>
				<div
					class="video_or_image__inner__video"
					v-if="video_source && video_poster && choice === 'video'"
				>
					<video-modal
						@isModalOpen="getModalData"
						:has_border="'no'"
						:video_poster="video_poster"
						:video_source="video_source"
					></video-modal>
				</div>
				<div
					class="video_or_image__inner__image"
					:class="{'two': image_two}"
					v-else
				>
					<img
						v-if="image"
						:src="image"
						alt="image"
					/>

					<img
						v-if="image_two"
						:src="image_two"
						alt="image"
					/>

				</div>
			</div>
			<caption
				:class="{'two': image_two}"
				v-if="caption && choice !== 'video'"
				v-html='caption'
			></caption>
			<caption
				:class="{'two': image_two}"
				v-if="caption_two && choice !== 'video'"
				v-html='caption_two'
			></caption>
		</div>
	</section>
</template>

<script>
import VideoModal from './VideoModal.vue';

export default {
	data() {
		return {
			theModalStatus: false,
		};
	},

	props: {
		choice: {},
		image: {},
		title: {},
		image_two: {},
		video_poster: {},
		video_source: {},
		size: {},
		caption: {},
		caption_two: {},
		data: {},
	},

	computed: {
		cssVars() {
			return {};
		},

		parsedData() {
			if (this.data) {
				return JSON.parse(this.data);
			} else {
				return null;
			}
		},
	},

	watch: {},

	methods: {
		getModalData(arg) {
			this.theModalStatus = arg;
			return arg;
		},
	},

	components: {
		VideoModal,
	},

	created() {},
	mounted() {},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.video_or_image {
	transition: 0.2s ease all;
	padding-top: var(--padding-top);
	padding-bottom: var(--padding-bottom);
	position: relative;
	overflow: hidden;
	background: white;

	@media (max-width: $mobile-xl) {
		padding-top: var(--padding-top-mobile);
		padding-bottom: var(--padding-bottom-mobile);
	}

	&::after {
		content: '';
		position: absolute;
		left: 0;
		top: 300px;
		height: calc(100% - 300px);
		width: 100%;
		background-color: var(--background-colour);
		z-index: 0;

		@media (max-width: $mobile-xl) {
			top: 150px;
			height: calc(100% - 150px);
		}
	}

	.container {
		z-index: 5;
		position: relative;
		// @media (max-width: $mobile-xl) {
		// 	padding: 0;
		// 	margin: 0;
		// 	max-width: 100%;
		// }
	}

	&.modal-open {
		z-index: 999;
		pointer-events: none;
		position: relative;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
	}

	caption {
		display: flex;
		flex-wrap: wrap;
		grid-column: 3 / span 8;
		border-bottom: 1px solid black;
		padding: 12px 0;
		font-size: 12px;
		line-height: 18px;
		text-align: left;

		@media (max-width: $mobile-xl) {
			grid-column: 1 / span 4;
		}

		&.two {
			&:first-of-type {
				grid-column: 2 / span 5;

				@media (max-width: $mobile-xl) {
					grid-column: 1 / span 2;
				}
			}

			&:last-of-type {
				grid-column: 7 / span 5;

				@media (max-width: $mobile-xl) {
					grid-column: 3 / span 2;
				}
			}
		}
	}

	&__inner {
		display: grid;
		grid-template-columns: repeat(12, 1fr);
		gap: var(--gutter-tablet-desktop);
		grid-column: span 12;

		@media (max-width: $mobile-xl) {
			grid-column: span 4;
			margin-right: 0;
		}

		h2 {
			grid-column: var(--size);
			text-align: center;
			font-weight: 400;
			color: var(--dark-green);
		}

		/* .single & {
			grid-column: 3 / span 8;
		}

		.anchored & {
			grid-column: 1 / span 12;
		}

		.single-project & {
			grid-column: 1 / span 12;

			@media (max-width: $mobile-xl) {
				grid-column: 1 / span 4;
			}
		} */

		&__video {
			grid-column: var(--size);
			/* border: var(--border); */
			// background: #ededed 0% 0% no-repeat padding-box;
			opacity: 1;

			@media (max-width: $mobile-xl) {
				grid-column: span 12;
				margin-right: 0;
			}
		}

		&__image {
			grid-column: var(--size);
			/* border: var(--border); */
			// background: #ededed 0% 0% no-repeat padding-box;
			aspect-ratio: 16 / 9;
			opacity: 1;

			&.two {
				display: grid;
				grid-template-columns: 1fr 1fr;
				gap: 24px;
				aspect-ratio: unset;

				img {
					aspect-ratio: 1 / 1;
				}
			}

			@media (max-width: $mobile-xl) {
				grid-column: span 12;
				margin-right: 0;
			}

			img {
				width: 100%;
				height: 100%;
				object-fit: cover;
				display: flex;
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/VideoImage.vue